import * as t from "react";
const e = t.createContext(void 0);
export {
  e as AlertDialogContext
};
